import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getSupportCategoriesApi,
  createSupportTicketApi,
  getMySupportTicketsApi,
  fetchSupportContactApi
} from "../../api/userApi";

export const fetchSupportCategories = createAsyncThunk(
  "support/fetchCategories",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getSupportCategoriesApi();
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to load categories");
    }
  }
);

export const fetchMyTickets = createAsyncThunk(
  "support/fetchMyTickets",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getMySupportTicketsApi();
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to load tickets");
    }
  }
);

export const createSupportTicket = createAsyncThunk(
  "support/createTicket",
  async (formData, { rejectWithValue }) => {
    try {
      const res = await createSupportTicketApi(formData);
      return res.data.data.ticket;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to create ticket");
    }
  }
);


// fetch support contact info
// fetch support contact info (state + district based)
export const fetchSupportContact = createAsyncThunk(
  "support/fetchSupportContact",
  async ({ stateId, districtId }, { rejectWithValue }) => {
    try {
      const res = await fetchSupportContactApi({
        state: stateId,
        district: districtId,
      });
      return res.data.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to load support contact"
      );
    }
  }
);

